import { Filter, FilterTypes } from 'components/FilterDrawer/FilterDrawer.config'

export const DEFAULT_PAGE_SIZE = 25
export const PAGE_SIZE_OPTIONS = [25, 50, 100]

export const filtersInitialState: Filter[] = [
  { name: 'experiences.jurisdiction', label: 'Jurisdiction', value: [] },
  { name: 'experiences.jobDepartment', label: 'Departments', type: FilterTypes.KEYWORD, value: [] },
  { name: 'experiences.startDate', label: 'Start Date', type: FilterTypes.DATE_BIT, value: [] },
  { name: 'experiences.endDate', label: 'End Date', type: FilterTypes.DATE_BIT, value: [] },
  { name: 'experiences.status', label: 'Employee Status', type: FilterTypes.KEYWORD, value: [] },
  {
    name: 'experiences.isExecutiveRole',
    label: 'Executives Only',
    activeFilterLabel: 'Executives Only',
    type: FilterTypes.BOOL,
    value: [],
  },
]
